import { generateState } from '../builder'

export default {
  countries: [],
  country: {},
  ...generateState('getCountries'),
  ...generateState('getCountry'),
}
